/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-17 16:11:58
 *
 *******************************************************/
export const BUTTON_STYLE = [
  { value: 'bc-al-style1', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle1_Label' },
  { value: 'bc-al-style2', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle2_Label' },
  { value: 'bc-al-style3', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle3_Label' },
  { value: 'bc-al-style4', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle4_Label' },
  { value: 'bc-al-style5', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle5_Label' },
  { value: 'bc-al-style6', label: 'AdminHTML.DefaultLayoutSettings.Constants.buttonStyle6_Label' }
];

export const QUICKVIEW_ADD_TO_CART_STYLE = {
  'bc-al-style1': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style2': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style3': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(0||0||0||1)',
    qvBtnTextColor: 'rgba(255||255||255||1)',
    qvBtnBorderColor: 'rgba(0||0||0||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(0||0||0||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(0||0||0||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style4': {
    qvEnable: true,
    atcEnable: true,
    // qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    // qvBtnTextColor: 'rgba(61||66||70||1)',
    // qvBtnBorderColor: 'rgba(255||255||255||1)',
    // qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    // qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    // qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    // atcBtnBackgroundColor: 'rgba(0||0||0||1)',
    // atcBtnTextColor: 'rgba(255||255||255||1)',
    // atcBtnBorderColor: 'rgba(0||0||0||1)',
    // atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    // atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    // atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(49||55||61||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(34||34||34||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(34||34||34||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style5': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnTextColor: 'rgba(61||66||70||1)',
    atcBtnBorderColor: 'rgba(255||255||255||1)',
    atcBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnHoverTextColor: 'rgba(255||255||255||1)',
    atcBtnHoverBorderColor: 'rgba(61||66||70||1)'
  },
  'bc-al-style6': {
    qvEnable: true,
    atcEnable: true,
    qvBtnBackgroundColor: 'rgba(255||255||255||1)',
    qvBtnTextColor: 'rgba(61||66||70||1)',
    qvBtnBorderColor: 'rgba(255||255||255||1)',
    qvBtnHoverBackgroundColor: 'rgba(61||66||70||1)',
    qvBtnHoverTextColor: 'rgba(255||255||255||1)',
    qvBtnHoverBorderColor: 'rgba(61||66||70||1)',
    atcBtnBackgroundColor: 'rgba(61||66||70||1)',
    atcBtnTextColor: 'rgba(255||255||255||1)',
    atcBtnBorderColor: 'rgba(61||66||70||1)',
    atcBtnHoverBackgroundColor: 'rgba(255||255||255||1)',
    atcBtnHoverTextColor: 'rgba(61||66||70||1)',
    atcBtnHoverBorderColor: 'rgba(255||255||255||1)'
  }
};
